export class CreateUserDto {
  email: string;
  password: string;
}

export class AddApplicationDto {
  email: string;
}
